import messages from '@/constants/messages.js';
import mixin from '@/mixin/index.js';
import managementServices from '@/services/management.services.js';
import categories from '@/constants/categories.js';
import calculators from '@/constants/calculators.enum.js';

const root = { root: true };

export default {
    async insertPhoto({ commit, dispatch, state }, { type, name, file, path }) {
        try {
            commit("general/setLoadingOn", true, root);
            let base64File = await mixin.methods._convertFileToDataUrl(file);
            base64File = base64File.split('base64,')[1];
            return await managementServices.insertPhoto(name, type, base64File, path || false, state.managementToken);
        } catch {
            dispatch("general/showError", messages.ERROR, root);
        } finally {
            commit("general/setLoadingOff", false, root);
        }
    },
    async getClasses({ commit, dispatch, state }) {
        commit("general/setLoadingOn", true, root);
        try {
            const classes = await managementServices.getClasses(state.managementToken);
            commit("drugs/setClasses", classes, root);
        }
        catch {
            dispatch("general/showError", messages.ERROR, root);
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    async deleteSelectedClass({ dispatch }, { classModel, classes }) {
        if (confirm("Deseja excluir a classe selecionada? Cuidado, esta ação pode refletir em problemas em todas as categorias que abrangem este filtro.")) {
            classes = mixin.methods._removeFromArrayWithName(classes, classModel);
            await dispatch("saveClass", classes);
            await dispatch("getClasses");
        }
    },
    async addNewClass({ dispatch }, { name, category, classes }) {
        if (confirm("Deseja salvar a nova classe?")) {
            classes = mixin.methods._removeFromArrayWithName(classes, name);
            classes.push({
                name: name.trim(),
                category: category
            })
            await dispatch("saveClass", classes);
            await dispatch("getClasses");
        }
    },
    async saveClass({ dispatch, commit, state }, classes) {
        commit("general/setLoadingOn", true, root);
        try {
            await managementServices.postClasses(classes, state.managementToken);
        }
        catch {
            dispatch("general/showError", messages.ERROR, root);
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    async deleteDrug({ commit, dispatch, state }, { id, category, tempExclusion, productExclusion }) {
        if (confirm('Deseja confirmar a exclusão do item selecionado?')) {
            commit("general/setLoadingOn", true, root);
            try {
                await managementServices.deleteDrug({ id, category, tempExclusion, productExclusion }, state.managementToken);
                dispatch("general/showMessage", messages.SUCCESS, root);
                window.location.reload();
            } catch (err) {
                console.log(err);
                dispatch("general/showError", messages.ERROR, root);
            } finally {
                commit("general/setLoadingOff", true, root);
            }
        }
    },
    async loginManagement({ commit, dispatch, state }) {
        if (state.managementUser) {
            return;
        }
        commit("general/setLoadingOn", true, root);
        try {
            if (process.env.VUE_APP_ENV == 'hml') {
                alert("Este é o ambiente de testes, não cadastre informações oficiais aqui!");
            }
            let user = prompt(messages.ENTER_USER);
            let password = prompt(messages.ENTER_PASSWORD);
            if (user && password) {
                const { token, profile } = await managementServices.loginManagement(user, password);
                commit("setManagementToken", token);
                commit("setManagementUser", user);
                commit("setProfile", profile);
                commit("general/setLoadingOff", true, root);
            } else {
                throw new Error();
            }
        } catch (err) {
            console.log(err);
            dispatch("general/showError", messages.ERROR, root);
        }
    },
    async getItemWithIdForManagement({ commit, dispatch, state }, { collection, productsCollection, id, temp }) {
        commit("general/setLoadingOn", null, root);
        collection = collection || 'drugs';
        collection = temp ? `${collection}_temp` : collection;
        productsCollection = productsCollection || 'veterinary_products';
        try {
            var item = await managementServices.getEntityItemById(collection, id.toLowerCase(), state.managementToken);
            commit('drugs/setDrug', item, root);
            if (!temp) {
                for (var i = 0; i < item.veterinary_products.length; i++) {
                    const id = item.veterinary_products[i].id.toLowerCase();
                    item.veterinary_products[i] =
                        await managementServices.getEntityItemById(productsCollection, id, state.managementToken);
                }
            }
            await dispatch("drugs/mapProducts", item, root);
        } catch (e) {
            console.log(e);
            dispatch('general/showError', messages.ERROR_GET_DRUG, root);
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    async saveItemAndProducts({ dispatch, commit, state }, drug) {
        commit("general/setLoadingOn", null, root);
        try {
            await managementServices.saveItemAndProducts(drug, state.managementToken);
            dispatch("general/showMessage", messages.SUCCESS, root);
            window.location.reload();
        } catch (error) {
            dispatch('general/showError', "Erro ao salvar droga", root);
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    readCSV({ commit, dispatch }, { file, caption }) {
        commit("general/setLoadingOn", null, root);
        var reader = new FileReader();
        reader.onload = function (e) {
            var csv = e.target.result;
            dispatch("processCSV", { csv, caption });
        };
        reader.onerror = function () {
            dispatch('general/showError', "Erro ao ler arquivo", root);
            commit("general/setLoadingOff", null, root);
        };
        reader.readAsText(file);
    },
    processCSV({ commit, dispatch }, { csv, caption }) {
        try {
            commit("general/setLoadingOn", null, root);
            var lines = csv.split(/\r\n|\n/);
            let data = [];
            const headers = lines[0].split(";");
            if (!headers.length || headers.length > 3) {
                throw new Error("Quantidade de colunas inválidas (max 3).");
            }
            for (let i = 1; i < lines.length; i++) {
                const line = lines[i].split(";");
                if (line.length != headers.length) {
                    throw new Error(`Linha ${i + 1} inválida. Por favor, siga o modelo proposto para importação do arquivo.`);
                }
                let obj = {};
                for (let j = 0; j < line.length; j++) {
                    obj[headers[j]] = line[j];
                }
                data.push(obj);
            }
            commit("setTable", {
                headers,
                lines: data,
                caption
            });
        } catch (e) {
            dispatch('general/showError', e, root);
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    processExcelResult({ commit, dispatch }, { rows, caption, name }) {
        try {
            commit("general/setLoadingOn", null, root);
            let data = [];
            let headers = [];
            let nullHeadersCount = 0;
            const addWhiteSpacesForHeaders = function (count) {
                let str = '';
                for (let i = 0; i < count; i++) {
                    str += ' ';
                }
                return str;
            };
            rows[0].forEach(r => {
                if (!r) {
                    nullHeadersCount += 1;
                    headers.push(addWhiteSpacesForHeaders(nullHeadersCount));
                } else {
                    headers.push(r);
                }
            });
            if (!headers.length) {
                throw new Error("Quantidade de colunas inválidas.");
            }
            for (let i = 1; i < rows.length; i++) {
                const row = rows[i];
                if (row.length != headers.length) {
                    throw new Error(`Linha ${i + 1} inválida. Por favor, siga o modelo proposto para importação do arquivo.`);
                }
                let obj = {};
                for (let j = 0; j < row.length; j++) {
                    if (!row[j]) {
                        obj[headers[j]] = '';
                    } else if (typeof row[j] == 'number') {
                        obj[headers[j]] = mixin.methods._formatNumber(row[j]);
                    } else {
                        obj[headers[j]] = row[j];
                    }
                }
                data.push(obj);
            }
            commit("setTable", {
                headers,
                lines: data,
                caption,
                name
            });
        } catch (e) {
            dispatch('general/showError', e, root);
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },

    // Topics Management 
    async getTopics({ dispatch, commit, state }) {
        try {
            commit("general/setLoadingOn", null, root);
            const response = await managementServices.getEntityItemById('configuration', 'topics', state.managementToken);
            commit("general/setLoadingOff", null, root);
            return mixin.methods._sortByProp(response.topics, 'name').filter(t => {
                return process.env.NODE_ENV == "development" || state.profile == 1 || ![
                    mixin.methods._getLabel('ALGORITHMS_TITLE'),
                    mixin.methods._getLabel('DISEASES_TITLE')
                ].includes(t.name);
            });
        } catch {
            dispatch("general/showError", messages.ERROR, root);
            return false;
        }
    },
    async addTopic({ state, commit, dispatch }, name) {
        commit("general/setLoadingOn", null, root);
        const topic = { name, subtopics: [] }
        try {
            return await managementServices.addTopic(topic, state.managementToken);
        } catch (err) {
            dispatch("general/showError", messages.ERROR, root);
            return false;
        } finally {
            commit("general/setLoadingOff", null, root);
        }

    },
    async addSubtopic({ state, commit, dispatch }, { name, topic }) {
        commit("general/setLoadingOn", null, root);
        try {
            const subtopic = await managementServices.addSubtopic({ name, topic }, state.managementToken);
            commit("general/setLoadingOff", null, root);
            return subtopic;
        } catch (err) {
            dispatch("general/showError", messages.ERROR, root);
            return false;
        }
    },
    async getSubtopicItems({ state, commit, dispatch }, { subtopic }) {
        try {
            commit("general/setLoadingOn", null, root);
            const { items } = await managementServices.getSubtopic(subtopic.id, state.managementToken);
            commit("general/setLoadingOff", null, root);
            return mixin.methods._sortByProp(items, 'name');
        } catch {
            dispatch("general/showError", messages.ERROR, root);
            return false;
        }
    },
    async addItem({ state, commit, dispatch }, { name, subtopic }) {
        commit("general/setLoadingOn", null, root);
        try {
            const item = await managementServices.addItem({ name, subtopic }, state.managementToken);
            commit("general/setLoadingOff", null, root);
            return item;
        } catch (err) {
            dispatch("general/showError", messages.ERROR, root);
            return false;
        }
    },
    async getItem({ state, commit, dispatch }, id) {
        try {
            commit("general/setLoadingOn", null, root);
            const item = await managementServices.getItem(id, state.managementToken);
            commit("general/setLoadingOff", null, root);
            if (item.sections.length == 0) {
                item.sections.push({ style: 0, text: "" });
                item.sections.push({ style: 1, text: "" });
            }
            return item;
        } catch {
            dispatch("general/showError", messages.ERROR, root);
            return false;
        }
    },
    async saveItemChanges({ commit, dispatch, state }, { name, synonyms, contentPoints, tree, id, references, sections, categories, animals, subtopics }) {
        try {
            commit("general/setLoadingOn", null, root);
            await managementServices.saveItemChanges(id, {
                name, synonyms, contentPoints, tree, references, sections, categories, animals, subtopics: subtopics || []
            }, state.managementToken);
            dispatch("general/showMessage", messages.SUCCESS, root);
        } catch {
            dispatch("general/showError", messages.ERROR, root);
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    async changeItemStatus({ commit, dispatch, state }, { id, available }) {

        const confirmationText = available ?
            `Aprovar e liberar o item? 

            Esta ação irá versionar a última versão do item seleciona e irá liberar a visualização dele no produto.

            (OK => Sim | Cancelar => Não)` :

            `Remover a disponibilidade do item?

            Esta ação irá desabilitar a última versão disponível deste item no produto.

            (OK => Sim | Cancelar => Não)`;

        if (confirm(confirmationText)) {
            try {
                commit("general/setLoadingOn", null, root);
                await managementServices.changeItemStatus(id, available, state.managementToken);
                dispatch("general/showMessage", messages.SUCCESS, root);
            } catch {
                dispatch("general/showError", messages.ERROR, root);
            } finally {
                commit("general/setLoadingOff", null, root);
            }
        }
    },
    async changeSubtopicStatus({ commit, dispatch, state }, { id, available }) {
        const confirmationText = available ?
            `Disponibilizar o subtópico? 

            Esta ação irá liberar a visualização do subtópico selecionado no produto.

            (OK => Sim | Cancelar => Não)` :

            `Remover a disponibilidade do subtópico?

            Esta ação irá desabilitar a disponibilidade deste subtópico no produto.

            (OK => Sim | Cancelar => Não)`;

        if (confirm(confirmationText)) {
            try {
                commit("general/setLoadingOn", null, root);
                await managementServices.changeSubtopicStatus(id, available, state.managementToken);
                dispatch("general/showMessage", messages.SUCCESS, root);
            } catch {
                dispatch("general/showError", messages.ERROR, root);
            } finally {
                commit("general/setLoadingOff", null, root);
            }
        }
    },
    async getInternalReference({ commit, dispatch, state }, link) {
        try {
            commit("general/setLoadingOn", null, root);
            const REFERENCE_TYPE = 1;
            if (link.includes('/doses/')) {
                let [category, collection, id, _doses, dose] = link.split('/categories/')[1].split('/');
                category = categories[parseInt(category) - 1];
                collection = collection.includes('drugs') ? category.collection : category.productsCollection;
                const item = await managementServices.getEntityItemById(collection, id, state.managementToken);

                let doseItem = item.doses[parseInt(dose)];
                delete doseItem.references;
                delete doseItem.sections;

                return {
                    id: `${id}_${dose}`,
                    name: item.name,
                    type: REFERENCE_TYPE,
                    category: `${category.portugueseName} | Doses`,
                    description: item.description || item.brand,
                    path: link.includes('#') ? link.split('#')[1] : link,
                    dose: doseItem
                };
            } else if (link.includes('/categories/')) {
                let [category, collection, id] = link.split('/categories/')[1].split('/');
                category = categories[parseInt(category) - 1];
                collection = collection.includes('drugs') ? category.collection : category.productsCollection;
                const item = await managementServices.getEntityItemById(collection, id, state.managementToken);
                return {
                    id,
                    name: item.name,
                    type: REFERENCE_TYPE,
                    category: category.portugueseName,
                    description: item.description || item.brand,
                    path: link.includes('#') ? link.split('#')[1] : link
                };
            } else if (link.includes('/item') || link.includes('/algorithms')) {
                const itemId = link.split('/algorithms').join('/item').split('/item/')[1];
                const topics = await dispatch('getTopics');
                const { id, name, subtopic_id } = await dispatch("getItem", itemId);
                let category, description = '';
                topics.forEach(t => {
                    const subtopic = t.subtopics.find(s => { return s.id == subtopic_id });
                    if (subtopic) {
                        category = t.name;
                        description = t.name == subtopic.name ? '' : subtopic.name;
                    }
                });
                return {
                    id,
                    name,
                    type: REFERENCE_TYPE,
                    category,
                    description,
                    path: link.includes('#') ? link.split('#')[1] : link
                };
            } else if (link.includes('/calculators')) {
                const id = link.split('/calculators/')[1].replace('/custom', '');
                const category = categories[6];
                const calculator = mixin.methods._filterArrayFromId(calculators, id)[0];

                return {
                    id,
                    name: calculator.name,
                    type: REFERENCE_TYPE,
                    category: category.portugueseName,
                    description: !!calculator.classes.length ? calculator.classes[0] : '',
                    path: link.includes('#') ? link.split('#')[1] : link
                };
            }
            throw new Error();
        } catch (err) {
            dispatch("general/showError", messages.ERROR, root);
            throw err;
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },

    //Customers Management
    async getCustomers({ commit, dispatch, state }, userAppUid) {
        try {
            commit("general/setLoadingOn", null, root);
            return await managementServices.getCustomers(userAppUid, state.managementToken);
        } catch (err) {
            dispatch("general/showError", messages.ERROR, root);
            throw err;
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    async getCustomerWithUid({ commit, dispatch, state }, uid) {
        try {
            commit("general/setLoadingOn", null, root);
            return await managementServices.getCustomerWithUid(uid, state.managementToken);
        } catch (err) {
            dispatch("general/showError", messages.ERROR, root);
            throw err;
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    async saveCustomerSettings({ commit, dispatch, state }, customer) {
        try {
            const { uid } = customer;
            commit("general/setLoadingOn", null, root);
            return await managementServices.saveCustomerSettings(uid, customer, state.managementToken);
        } catch (err) {
            dispatch("general/showError", messages.ERROR, root);
            throw err;
        } finally {
            commit("general/setLoadingOff", null, root);
        }
    },
    async setupTreeAlgorithm({ }, { csv, sections }) {
        if (!csv) {
            return null;
        }
        let lines = csv.replace(/\"/g, '').replace("Name;Parent;Decision;Shape;Color", "").split(/\r\n|\n/);
        let tree = {};
        let processed = [];
        const isACopy = function (child) {
            return !!lines.find(line => {
                let [nodeNumber, parent, _decision, _shape, color] = line.split(';');
                return nodeNumber == child.nodeNumber && parent == child.parent && color != child.color;
            })
        }
        const getNodeDetails = function (child) {
            let node = { ...child };
            sections.forEach((section, index) => {

                if (section.style == 1 && section.text.trim() == child.nodeNumber.trim()) {
                    if ("Rectangle" == child.shape) {
                        node["type"] = 1;
                        node["child"] = null;
                        node["sections"] = [];
                        for (let iterator = (index + 1); iterator < sections.length; iterator++) {
                            if ([0, 1].includes(sections[iterator].style)) {
                                break;
                            } else if ([2, 3, 4].includes(sections[iterator].style)) {
                                node["sections"].push(sections[iterator]);
                            }
                        }
                    } else if ("Diamond" == child.shape) {
                        node["type"] = 2;
                        node["child"] = null;
                        node["options"] = [];
                        node["question"] = sections[index + 1].text;
                    } else {
                        node["child"] = null;
                        node["title"] = sections[index + 1].text;
                    }
                }
            })
            return node;
        }
        const findChildParent = function (parent, child) {
            try {
                if (["Rectangle", "Circle", "Oval"].includes(parent.shape)) {
                    if (parent.nodeNumber == child.parent && (parent.color == child.color || !isACopy(child))) {
                        parent['child'] = getNodeDetails(child);
                        return;
                    }
                    findChildParent(parent.child, child);
                } else if ("Diamond" == parent.shape) {
                    if (parent.nodeNumber == child.parent && (parent.color == child.color || !isACopy(child))) {
                        if (!parent['options']) parent['options'] = [];
                        if ("Diamond" == child.shape) {
                            parent['child'] = getNodeDetails(child);
                        } else if (!parent['options'].find(o => { return o.nodeNumber == child.nodeNumber })) {
                            parent['options'].push(getNodeDetails(child));
                        }
                        return;
                    }

                    if (!!parent['child']) {
                        findChildParent(parent.child, child);
                    } else {
                        parent['options'].forEach(option => {
                            findChildParent(option, child);
                        });
                    }
                }
            } catch {
                return;
            }
        }

        lines.forEach((line, index) => {
            if (!line.trim() || processed.includes(index)) {
                return;
            }
            let [nodeNumber, parent, _decision, shape, color] = line.split(';');
            let node = { nodeNumber, parent, shape, color };
            if (parent == -1) {
                tree = getNodeDetails(node);
                return;
            }
            findChildParent(tree, node);
        });
        return JSON.stringify(tree);
    }
}